export const TICKET_MODAL_WIDTH = 860;
